// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1GuiI","imageUploader":"EGiftCard_imageUploader__1F7H-"};